import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const RejectUpdateRequestModal = ({
    show,
    onClose,
    selectedReason,
    onSelectChange,
    customReason,
    onCustomReasonChange,
    onSave,
    reasons = [],
    loader
}) => {
    return (
      <Modal
        className="customer-modal-without-header-footer"
        show={show}
        onHide={onClose}
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>What's the reason?</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <FormControl fullWidth margin="dense" variant="outlined">
              <InputLabel>Select a reason</InputLabel>
              <Select
                value={selectedReason}
                onChange={onSelectChange}
                label="Select a reason"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      width: "calc(360px - 32px)",
                      whiteSpace: "normal",
                    },
                  },
                }}
              >
                {reasons.map((reason, index) => (
                  <MenuItem
                    key={index}
                    value={reason}
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    {reason}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Form.Group controlId="customReason" className="mt-3">
              <Form.Label>Reason</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                value={customReason}
                onChange={onCustomReasonChange}
                style={{ height: "150px" }}
                autoFocus
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            style={{
              background: "linear-gradient(90deg, #FC8C66, #F76A7B)",
              border: "none",
              color: "#fff",
            }}
            disabled={loader}
          >
            Save
            {loader && (
              <div
                className="spinner-border spinner-border-sm"
                style={{ marginLeft: "10px" }}
                role="status"
              >
                <span className="sr-only"></span>
              </div>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

export default RejectUpdateRequestModal;
